<template>
    <div class="icon-picker" v-on-clickaway="closeIconGrid">
        <div class="icon-selected form-input" @click.prevent="toggleIconGrid"  :class="showIconGrid && 'focus'">
            <i class="selected fa" :class="iconSelected"></i>
            <i class="fa fa-caret-down"></i>
        </div>
        <div class="icon-grid-container" :class="{show:showIconGrid}" >
            <div class="icon-grid scroll pb-0">
                <div class="icon" v-for="icon in icons" @click.prevent="selectIcon(icon)">
                    <i class="fa" :class="icon"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import {mixin as clickaway} from 'vue-clickaway';

    export default {
        name: 'IconPicker',
        props: {
            icon: {
                type: String,
                default: null
            }
        },
        mixins: [clickaway],
        methods: {
            toggleIconGrid: function(){
                this.showIconGrid = !this.showIconGrid;
            },
            closeIconGrid: function(){
                this.showIconGrid = false;
            },
            selectIcon: function(icon){
                this.iconSelected = icon;
                this.showIconGrid = false;
            },
            getRandomIcon: function(){
                return this.icons[Math.floor(Math.random() * this.icons.length)];
            },
        },
        mounted: function(){
            this.iconSelected = this.icon;
        },
        watch: {
            icon: function(newValue) {
                this.iconSelected = newValue.replace('fa ','') || this.getRandomIcon();
            },
            iconSelected: function(newValue) {
                this.$emit('change', newValue || this.getRandomIcon());
            }
        },
        data: () => ({
            iconSelected: null,
            showIconGrid: false,
            icons: [
                'fa-address-book', 'fa-address-book-o', 'fa-address-card', 'fa-address-card-o', 'fa-ambulance',
                'fa-anchor', 'fa-archive','fa-asterisk',
                'fa-at', 'fa-automobile', 'fa-balance-scale', 'fa-bank',
                'fa-bath', 'fa-bed', 'fa-beer', 'fa-bell',
                'fa-bell-o', 'fa-bicycle', 'fa-binoculars', 'fa-birthday-cake','fa-black-tie', 'fa-blind', 'fa-bolt',
                'fa-bomb', 'fa-book', 'fa-bookmark', 'fa-bookmark-o', 'fa-briefcase', 'fa-bug', 'fa-building',
                'fa-building-o', 'fa-bullseye', 'fa-bus', 'fa-cab', 'fa-calculator',
                'fa-calendar-o', 'fa-camera',
                'fa-car', 'fa-certificate', 'fa-chain-broken','fa-child', 'fa-clock-o',
                'fa-cloud','fa-coffee', 'fa-compass', 'fa-crosshairs', 'fa-cube', 'fa-cubes', 'fa-cut', 'fa-cutlery', 'fa-dashboard', 'fa-database', 'fa-desktop', 'fa-diamond', 'fa-dollar',
                'fa-drivers-license', 'fa-drivers-license-o', 'fa-envelope', 'fa-envelope-o', 'fa-envelope-open',
                'fa-envelope-open-o', 'fa-envira', 'fa-eur',
                'fa-exclamation', 'fa-exclamation-circle', 'fa-exclamation-triangle',
                'fa-eye', 'fa-eye-slash', 'fa-eyedropper', 'fa-fax', 'fa-female',
                'fa-fighter-jet',
                'fa-fire', 'fa-fire-extinguisher', 'fa-flag', 'fa-flag-checkered',
                'fa-flag-o', 'fa-flask', 'fa-floppy-o', 'fa-fort-awesome', 'fa-frown-o', 'fa-futbol-o', 'fa-gamepad', 'fa-gavel',
                'fa-gift', 'fa-glass', 'fa-globe',
                'fa-graduation-cap',
                'fa-hand-o-down', 'fa-hand-o-left', 'fa-hand-o-right', 'fa-hand-o-up', 'fa-hand-paper-o',
                'fa-hand-peace-o', 'fa-hand-pointer-o', 'fa-hand-rock-o', 'fa-hand-scissors-o', 'fa-hand-spock-o', 'fa-hand-stop-o',
                'fa-handshake-o', 'fa-headphones', 'fa-heart', 'fa-heart-o',
                'fa-heartbeat', 'fa-home', 'fa-hospital-o', 'fa-hourglass',
                'fa-hourglass-o',
                'fa-id-badge', 'fa-id-card', 'fa-id-card-o',
                'fa-industry', 'fa-info', 'fa-info-circle', 'fa-institution', 'fa-intersex',
                'fa-key',
                'fa-laptop', 'fa-leaf', 'fa-lemon-o',
                'fa-life-ring', 'fa-lightbulb-o', 'fa-link',
                'fa-location-arrow', 'fa-lock',
                'fa-magic', 'fa-magnet', 'fa-male', 'fa-map',
                'fa-map-marker', 'fa-map-o', 'fa-map-pin', 'fa-map-signs',
                'fa-medkit',
                'fa-microchip', 'fa-microphone',
                'fa-money', 'fa-moon-o', 'fa-motorcycle',
                'fa-music', 'fa-newspaper-o',
                'fa-paint-brush', 'fa-paper-plane', 'fa-paper-plane-o', 'fa-paperclip',
                'fa-paw', 'fa-pencil',
                'fa-percent', 'fa-phone',
                'fa-plane',
                'fa-plug',
                'fa-puzzle-piece',
                'fa-question-circle', 'fa-question-circle-o',
                'fa-recycle',
                'fa-road', 'fa-rocket',
                'fa-send-o', 'fa-server',
                'fa-shield', 'fa-ship', 'fa-shopping-bag',
                'fa-shopping-basket', 'fa-shopping-cart', 'fa-shower', 'fa-signal',
                'fa-signing', 'fa-sitemap', 'fa-sliders',
                'fa-snowflake-o', 'fa-soccer-ball-o', 'fa-space-shuttle',
                'fa-spoon', 'fa-star',
                'fa-star-o',
                'fa-stethoscope', 'fa-sticky-note', 'fa-sticky-note-o',
                'fa-suitcase', 'fa-sun-o',
                'fa-taxi',
                'fa-thermometer-full', 'fa-thumb-tack',
                'fa-thumbs-down', 'fa-thumbs-o-down', 'fa-thumbs-o-up', 'fa-thumbs-up', 'fa-ticket',
                'fa-train', 'fa-trash', 'fa-trash-o', 'fa-tree', 'fa-trophy', 'fa-truck',
                'fa-umbrella', 'fa-university', 'fa-unlock', 'fa-unlock-alt',
                'fa-user', 'fa-user-circle', 'fa-user-circle-o', 'fa-user-md', 'fa-user-o',
                'fa-user-secret',
                'fa-video-camera',
                'fa-wheelchair', 'fa-wheelchair-alt', 'fa-wrench'
            ]
        })
    }
</script>


